<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="groupUsersState.list"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="groupUsersState.loading"
          :style="{ opacity: groupUsersState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay usuarios para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('List', [
      'groupUsersState'
    ]),
    optionSelected() {
      return this.groupUsersState.list.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.groupUsersState.list.length
        || !this.parentValue
        || this.groupUsersState.loading;
    }
  },
  methods: {
    ...mapActions('List', [
      'getUsersGroup'
    ]),
    onInput(event) {
      this.$emit('input', event?.value);
      this.setPosition(event?.value);
    },
    getOption() {
      return this.groupUsersState.list.find((option) => option.value === this.value);
    },
    setPosition(userId) {
      const user = this.groupUsersState.list.find((option) => option.value === userId);
      this.$emit('set-position', user);
    }
  },
  created() {
    if (this.nested) {
      // TODO: this.clearDocuments();
      this.$watch('parentValue', (newValue, oldValue) => {
        if (newValue !== oldValue) {
          if (oldValue !== '') {
            this.$emit('input', '');
          }
          if (newValue !== '') {
            this.getUsersGroup(newValue);
          }
        }
      });

      if (this.parentValue !== '') {
        this.getUsersGroup(this.parentValue);
      }
    } else if (this.parentValue !== '') {
      this.getUsersGroup(this.parentValue);
    }
  },
  props: {
    name: { type: String, required: true },
    label: { type: String, default: 'Nombre de Persona que Genera Documento' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    nested: { type: Boolean, default: true },
    parentValue: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false }
  }
};

</script>
